module.exports = __webpack_public_path__ + "img/question14c4.3e12625d.png";